import { Color, Option } from 'types';

export const getAvailableOptionsByUpgrade = (
	options: Option[],
	selectedUpgrade: number
): Option[] => {
	const available: Option[] = [];
	options.forEach((option) => {
		if (option.linkedVehicles.includes(selectedUpgrade)) available.push(option);
	});
	return available.sort((a, b) => a.monthPrice - b.monthPrice);
};

export const getAvailableColorsByUpgrade = (colors: Color[], selectedUpgrade: number): Color[] => {
	const available: Color[] = [];

	colors.forEach((color) => {
		if (
			color.linkedVehicles.includes(selectedUpgrade) &&
			color.primaryRgbHighlightCode // skip color if primaryRgbHighlightCode is missing
		) {
			available.push(color);
		}
	});

	return available.sort((a, b) => {
		if (a.price !== b.price) {
			return a.price - b.price;
		}
		return a.id - b.id;
	});
};
